import {
  SessionFileFragment,
  TrainingClassFileFragment,
  TrainingFileFragment,
  TrainingMembershipFileFragment,
} from 'generated/resources/graphql'

import type { File } from 'modules/trainings/components/Files/FileViewer'

export type FileType = 'SessionFile' | 'TrainingFile' | 'TrainingMembershipFile' | 'ClassFile'

type BuildFileListParams = {
  fileNavigation?: (fileId: string) => string | undefined
  trainingFiles?: TrainingFileFragment[]
  sessionFiles?: SessionFileFragment[]
  membershipFiles?: TrainingMembershipFileFragment[]
  classFiles?: TrainingClassFileFragment[]
}

export const useTrainingsMixedFiles = () => {
  const buildFileUrl = (fileType: FileType, fileId: string) => {
    return fileType.concat(`-${fileId}`)
  }

  const buildFilesList = ({
    fileNavigation,
    trainingFiles,
    sessionFiles,
    membershipFiles,
    classFiles,
  }: BuildFileListParams): File[] => {
    const allFiles: File[] = []

    trainingFiles &&
      allFiles.push(
        ...trainingFiles.map((file): File => {
          const url = buildFileUrl('TrainingFile', file.id)
          return {
            id: file.id,
            contentType: file.contentType || '',
            filename: file.title || file.filename,
            url: file.url,
            navigation: fileNavigation ? fileNavigation(url) : '',
            type: 'training',
          }
        })
      )

    classFiles &&
      allFiles.push(
        ...classFiles.map((file): File => {
          const url = buildFileUrl('ClassFile', file.id)
          return {
            id: file.id,
            contentType: file.contentType || '',
            filename: file.title || file.filename,
            url: file.url,
            navigation: fileNavigation ? fileNavigation(url) : '',
            type: 'trainingClass',
          }
        })
      )

    sessionFiles &&
      allFiles.push(
        ...sessionFiles.map((file): File => {
          const url = buildFileUrl('SessionFile', file.id)
          return {
            id: file.id,
            contentType: file.contentType || '',
            filename: file.title || file.filename,
            url: file.url,
            navigation: fileNavigation ? fileNavigation(url) : '',
            type: 'trainingClass',
          }
        })
      )

    membershipFiles &&
      allFiles.push(
        ...membershipFiles.map((file): File => {
          const url = buildFileUrl('TrainingMembershipFile', file.id)
          return {
            id: file.id,
            contentType: file.contentType || '',
            filename: file.filename,
            url: file.url,
            navigation: fileNavigation ? fileNavigation(url) : '',
            type: 'membership',
          }
        })
      )

    return allFiles
  }

  return {
    buildFilesList,
  }
}
